/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageFile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageFile({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Content/Actions/Upload/Content/Documents/Content/SystemFiles/Preview/Content/PreviewSection/ImageFile"
  
}) {
let patientDocumentsPreviewFilePreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'patient_documents',
path: 'preview_file.preview_url',
})
  return (<React.Fragment
>
<div
  data-testid="ImageFile.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<img
  data-testid="ImageFile.Image"
  data-view-path={viewPath}
 alt={""}
 src={patientDocumentsPreviewFilePreviewUrlValueData}
 className={`views-block ${styles.Image}`}
/>
</div>
{children}
</React.Fragment>)
}